import React from "react";
import { Tooltip as MUITooltip, Fade, TooltipProps as MUITooltipProps } from "@mui/material";

import  './Tooltip.sass'

const Tooltip: React.FC<MUITooltipProps> = (props) => {
  return (
    <MUITooltip
      enterDelay={200}
      TransitionComponent={Fade}
      {...props}
    >
      {props.children || <div />}
    </MUITooltip>
  );
};

export default Tooltip;
